import { CurrencyTypeEnum, LocationRegisterType, PrintModeType } from "src/graphql/quark/quark.type"

export const REGISTER_TYPE_OPTIONS = [
  { value: LocationRegisterType.SalesRegister, label: "Sales Register" },
  { value: LocationRegisterType.CartRegister, label: "Cart Register" }
]

export const PRINT_MODE_OPTIONS = [{ value: PrintModeType.Thermal, label: "Thermal" }]

export const CURRENCY_OPTIONS = Object.values(CurrencyTypeEnum).map((currency) => ({
  value: currency,
  label: currency
}))
